const apiVersion = 'v1'

let url = 'https://loca.shop/'
let domain = 'https://api.loca.shop/'
let cdnDomain = 'https://images.loca.shop/'
let adminUrl = 'https://gestao.loca.shop'

if (process.env.NODE_ENV !== 'production') {
  url = 'http://localhost:8080/'
  domain = 'http://api.locashop.local/'
  cdnDomain = 'http://api.locashop.local/'
  adminUrl = 'http://localhost:3000'
}
if (process.env.NODE_ENV === 'demo') {
  url = 'https://demo.loca.shop/'
  domain = 'https://demoapi.loca.shop/'
  cdnDomain = 'https://demoimages.loca.shop/'
  adminUrl = 'https://demogestao.loca.shop'
}
if (process.env.NODE_ENV === 'homolog') { // HOMOLOG
  url = 'https://homolog.loca.shop/'
  domain = 'https://api-homolog.loca.shop/'
  cdnDomain = 'https://images.test.loca.shop/'
  adminUrl = 'https://gestao-homolog.loca.shop/'
}

export const companyName = 'Loca.Shop'
export const companyCnpj = '28.872.852/0001-98'
export const companyAddress = 'R. Zircônio, 288, Camargos, Belo Horizonte/MG - CEP: 30520-170'

export const appDomain = url
export const apiDomain = domain
export const apiURL = apiDomain + apiVersion
export const cdnURL = cdnDomain
export const adminURL = adminUrl

export const userURL = 'user'
export const companyURL = 'companies'
export const usersURL = 'users'
export const loginURL = apiDomain + 'oauth/token'
export const passwordEmailURL = 'password/email'
export const passwordResetURL = 'password/reset'



// WEBPACK FOOTER //
// ./src/config.js